import { render } from "./ManageCompany.vue?vue&type=template&id=2543f87c&scoped=true"
import script from "./ManageCompany.vue?vue&type=script&lang=js"
export * from "./ManageCompany.vue?vue&type=script&lang=js"

import "./ManageCompany.vue?vue&type=style&index=0&id=2543f87c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2543f87c"]])

export default __exports__